module.exports = __webpack_public_path__ + "static/media/bike3f.11ecaf9c.jpg";